import { render } from "./MoreArticle.vue?vue&type=template&id=ff84acfc&scoped=true"
import script from "./MoreArticle.vue?vue&type=script&lang=js"
export * from "./MoreArticle.vue?vue&type=script&lang=js"

import "./MoreArticle.vue?vue&type=style&index=0&id=ff84acfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff84acfc"]])

export default __exports__